import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import {
  OverviewContainer,
  OverviewTitle,
  OverviewLogosContainer,
  LoginButton,
  ImageContainer,
  DesktopContentLayout,
  OverviewTitleDesktop,
  OverviewLogosContainerDesktop,
  LoginButtonDesktop,
} from "./styles";

import { getPartnerImageUrl } from "utils/getImageUrl";
import { configState } from "state/config-slice";
import breakpoints from "themes/default/breakpoints";
import getOpco from "utils/getOpco";

const SimpleSlider = React.lazy(
  () => import(/* webpackChunkName: "SimpleSlider", webpackPrefetch: true */ "components/Slider/Slider"),
);

const logos = ["atresplayer", "netflix", "audible", "disney", "eurosport", "filmin", "hbo", "amazon", "tidal"];

const HomepageOverview: FunctionComponent = () => {
  const { t } = useTranslation();

  const config = useSelector(configState);
  const OpcolessCdnUrl = config.cdnUrl.replace(`/${getOpco()}/`, "/");

  const url = config.openidUrls?.find((el) => el.type === "bronze" || el.type === "gold")?.url as string;

  return (
    <OverviewContainer>
      <OverviewTitle>{t("Everything you love in one place.")}</OverviewTitle>
      <ImageContainer>
        <picture>
          <source
            media={`(min-width:${breakpoints.values.lg}px)`}
            srcSet={getPartnerImageUrl("generic/overview-image-desktop.webp", OpcolessCdnUrl)}
          />
          <source
            media={`(min-width:${breakpoints.values.md}px)`}
            srcSet={getPartnerImageUrl("generic/overview-image-tablet.webp", OpcolessCdnUrl)}
          />
          <img src={getPartnerImageUrl("generic/overview-image-mobile.webp", OpcolessCdnUrl)} alt="homepage-overview" />
        </picture>
      </ImageContainer>
      <OverviewLogosContainer>
        <SimpleSlider slides={logos} />
      </OverviewLogosContainer>
      <LoginButton href={url}>{t("Login To Get Started")}</LoginButton>

      <DesktopContentLayout>
        <OverviewTitleDesktop>{t("Everything you love in one place.")}</OverviewTitleDesktop>
        <OverviewLogosContainerDesktop>
          <SimpleSlider slides={logos} />
        </OverviewLogosContainerDesktop>
        <LoginButtonDesktop href={url}>{t("Login To Get Started")}</LoginButtonDesktop>
      </DesktopContentLayout>
    </OverviewContainer>
  );
};

export default React.memo(HomepageOverview);
